import { render, staticRenderFns } from "./historySim.vue?vue&type=template&id=d3cf7fd4&scoped=true&"
import script from "./historySim.vue?vue&type=script&lang=js&"
export * from "./historySim.vue?vue&type=script&lang=js&"
import style0 from "./historySim.vue?vue&type=style&index=0&id=d3cf7fd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3cf7fd4",
  null
  
)

export default component.exports